/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

const scrollTo = (id) => () => {
  const element = document.querySelector(id)

  if (!element) {
    return false
  }

  element.scrollIntoView({ behavior: 'smooth' })
}

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  if (
    prevRouterProps?.location.pathname === routerProps.location.pathname &&
    routerProps.location.hash.length > 0
  ) {
    window.setTimeout(scrollTo(routerProps.location.hash), 10)

    return false
  }

  return (
    prevRouterProps?.location.pathname !== routerProps.location.pathname &&
    routerProps.location.hash.length === 0
  )
}

export const onRouteUpdate = ({ location }) => {
  if (location.hash) {
    window.setTimeout(scrollTo(location.hash), 10)
  }
}
